// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/communication-tool/communication-tool-list/communication-tool-list.scss
// module id = 501
// module chunks = 0